import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import {useArticleService} from "../../services/article-service";
import DataTableBase from "../../components/datatable/data-table-base";
import AddEditArticleModal from "./add-edit-article-modal";
import DataTableActions from "../../components/datatable/data-table-actions";

export default function ArticlesList () {
  let articleService = useArticleService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const addEditModal = useRef();

  useEffect(()=>{
    articleService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, []);

  const onAddEditAction = (row=null, e=null)=>{
    addEditModal.current.openModal(row);
  };

  const onAddEditCallbackAction = (item=null)=>{
    console.log('onAddEditCallbackAction');
    setRows(HelperService.addOrReplaceItemInList(rows,item));
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      articleService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const columns = [{
    name: 'Názov',
    selector: row => row.title,
    sortable: true,
  },{
    name: 'Napojenie budovy',
    selector: row => row.building?.title,
    sortable: true,
  },{
    name: 'Publikované',
    center: true,
    selector: row => row.is_published,
    format: row => <span title="Publikované" className={`badge bg-${row.is_published?'success':'warning'}`}>{row.is_published?'Publikované':'Návrh'}</span>,
    filterSelector: row => { return row.is_published?'Publikované':'Návrh' },
    sortable: true,
  },{
    cell: row => <DataTableActions row={row} actions={[
      {title: 'Upraviť', icon: <span className="mdi mdi-book-edit-outline"></span>, action: onAddEditAction, className: 'hover-text-primary'},
      {title: 'Zmazať', icon: <span className="mdi mdi-trash-can-outline"></span>, action: onDelAction, className: 'hover-text-danger'},
    ]} />,
    right: true,
    allowOverflow: true,
    button: false,
  }];

  return (
    <>

      <AddEditArticleModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Články</PageTitle>

          <button className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                  <DataTableBase
                    progressPending={!loaded}
                    columns={columns}
                    data={rows}
                    // onRowClicked={(row)=>navigate(`${AppRoutes.users.path}/${row.id}`)}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

    </>
  );
}

ArticlesList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

ArticlesList.getSEO = function getSEO() {
  return {
    title: "Články",
  }
}
